import adminApiClient from './apiClient.js';

export const dashboardApi = {
  getStats: async () => {
    const { data } = await adminApiClient.get('/dashboard/stats');
    return data;
  },
  getUsuariosDiario: async (dias = 30) => {
    const { data } = await adminApiClient.get('/dashboard/insights/usuarios-diario', { params: { dias } });
    return data;
  },
  getSpacesDiario: async (dias = 30) => {
    const { data } = await adminApiClient.get('/dashboard/insights/spaces-diario', { params: { dias } });
    return data;
  },
  getCheckinsDiario: async (dias = 30) => {
    const { data } = await adminApiClient.get('/dashboard/insights/checkins-diario', { params: { dias } });
    return data;
  },
};

export default dashboardApi;
